import { render, staticRenderFns } from "./lottery-setting.vue?vue&type=template&id=34bcd58c&"
import script from "./lottery-setting.vue?vue&type=script&lang=js&"
export * from "./lottery-setting.vue?vue&type=script&lang=js&"
import style0 from "./lottery-setting.vue?vue&type=style&index=0&id=34bcd58c&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports